import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import type { OnyxColor } from '@onyx/angular';
import { OnyxLinkComponent } from '@onyx/angular';
import type { BusinessModule } from '../../../auth/common/enums/business/business-module';
import { AuthStore } from '../../../auth/common/stores/auth.store';

@Component({
  selector: 'app-module-link',
  imports: [OnyxLinkComponent, NgTemplateOutlet],
  templateUrl: './module-link.component.html',
})
export class ModuleLinkComponent {
  protected readonly authStore = inject(AuthStore);

  public readonly module = input.required<`${BusinessModule}`>();
  public readonly color = input.required<OnyxColor | null>();
  public readonly font = input<`f-${string}`>('f-body-m');

  public readonly linkClick = output();
}
